export default __webpack_public_path__ + "static/media/leaf.a69a46dd.svg";